module.exports = "<iframe\n  id=\"jotForm\"\n  jot-form-embed=\"JotFormCtrl.jotFormId\"\n  title=\"{{JotFormCtrl.jotFormTitle}}\"\n  onload=\"window.parent.scrollTo(0,0)\"\n  allowtransparency=\"true\"\n  allowfullscreen=\"true\"\n  allow=\"geolocation; microphone; camera\"\n  ng-src=\"{{JotFormCtrl.jotFormUrl}}\"\n  frameborder=\"0\"\n  style=\"\n  min-width: 100%;\n  height:539px;\n  border:none;\"\n  scrolling=\"no\"\n></iframe>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/jotForm/template.html
// module id = 1364
// module chunks = 0